import callNativeMethod from './callNativeMethod';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';
import checkIfInterfaceExist from './checkIfInterfaceExist';

/**
 * @return {*}
 */
const getCryptoVersionKey = (clientId, hostId) => {
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.getCryptoVersionKey,
    parameters: {
      argument1: clientId,
      argument2: hostId,
    },
  };
  try {
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    if (checkIfInterfaceExist('getCryptoVersionKey')) {
      return myInterface.getCryptoVersionKey(clientId, hostId);
    }
  }
};

export default getCryptoVersionKey;
